import React, { Component } from 'react';
import {array, func, string, bool} from 'prop-types';

import ShowCase from '@components/ShowCase/ShowCase';
import Preview from '@components/ShowCase/Preview/Preview';
import Controls from '@components/ShowCase/Controls/Controls';
import ModalPreviewer from '@components/ModalPreviewer/ModalPreviewer';

export default class BannersShowcase extends Component {

  static propTypes = {
    component: func.isRequired,
    optionsGroup: array,
    backgrounds: array,
    codeTemplate: string,
    previewClassName: string,
    modalPreviewClassName: string,
    modalOpened: bool
  };

  render() {
    const {
      component,
      optionsGroup,
      backgrounds,
      codeTemplate,
      previewClassName,
      modalPreviewClassName,
      modalOpened
    } = this.props;

    return (
      <ShowCase codeTemplate={codeTemplate}>
        <Preview className={previewClassName}>
          {selectedOptions => (
            <ModalPreviewer
              previewText="Preview Banner"
              imagePath={selectedOptions.imagePath}
              className={modalPreviewClassName}
              modalOpened={modalOpened}
            >
              {component(selectedOptions)}
            </ModalPreviewer>
          )}

        </Preview>
        <Controls optionsGroup={optionsGroup} backgrounds={backgrounds} />
      </ShowCase>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/components/Banner/BannersShowcase.js